import data from './data.md';
import image from './assets/hero-image.jpg';

export default {
  data,
  hero: { media: { image } },
  links: [],
};
